<template>
  <!-- Analysis -->
  <div class="row f-row justify-content-center h-100">
    <div class="col col-12 f-row" style="padding: 0 10px 0 10px;">
      <div class="h-100 d-flex flex-column">
        <div class="row f-row">
          <!-- Controls -->
          <div class="col col-12" style="padding: 0 5% 0 5%">
            <table
              class="table table-sm table-borderless table-data-controls"
              style="width: 100%;"
            >
              <tbody>
                <tr>
                  <td style="width: 10%" class="txt-label-primary-3">
                    <v-text-field
                      dark
                      v-model="search"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    >
                    </v-text-field>
                  </td>
                  <td
                    style="width: 7.5%"
                    class="txt-label-primary-3 text-right"
                  >
                    Filter by tag:
                  </td>
                  <td style="width: 8.5%" class="txt-label-primary-3">
                    <select
                      class="dropdown-form"
                      value="0"
                      v-model="selectedTag"
                      @change="onUserTagSelection"
                    >
                      <option
                        v-for="(tag, index) in tags"
                        :value="tag.id"
                        :key="index"
                      >
                        {{ tag.name.toUpperCase() }}
                      </option>
                    </select>
                  </td>
                  <td
                    style="width: 7.5%"
                    class="txt-label-primary-3 text-right"
                  >
                    Filter by author:
                  </td>
                  <td style="width: 7.5%" class="txt-label-primary-3">
                    <select
                      class="dropdown-form"
                      v-model="selectedAuthor"
                      @change="onUserCompanySelection"
                    >
                      <option
                        v-for="author in authors"
                        :value="author.company"
                        :key="author.id"
                      >
                        {{ author.company.toUpperCase() }}
                      </option>
                    </select>
                  </td>

                  <td style="width: 30%" class="txt-label-primary-3">
                    <v-pagination
                      dark
                      prev-icon="fa fa-chevron-left"
                      next-icon="fa fa-chevron-right"
                      v-model="page"
                      :length="pageCount"
                    >
                    </v-pagination>
                  </td>
                  <td style="width: 5%" class="txt-label-primary-3 text-left">
                    {{ page }} / {{ pageCount }}
                  </td>
                  <td
                    class="txt-label-primary-3 text-right"
                    style="width: 7.5%; padding-right: 5px"
                  >
                    Items/page:
                  </td>
                  <td style="width: 5%" class="txt-label-primary-3">
                    <v-text-field
                      dark
                      :value="itemsPerPage"
                      type="number"
                      min="1"
                      max="1000"
                      @input="itemsPerPage = parseInt($event, 10)"
                    >
                    </v-text-field>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- Cards -->
        <br />
        <div class="row f-row justify-content-center h-100">
          <div class="col col-9 h-100 scrl80">
            <div
              class="card"
              v-for="(report, index) in reports"
              :value="index"
              :key="report.id"
              style="border-bottom: 1px solid var(--lightbackground)"
            >
              <div class="row f-row">
                <div class="col col-4 text-center mt-3 mb-3">
                  <router-link
                    to="report.link"
                    tag="img"
                    :src="report.img"
                    class="report-image mx-auto d-block"
                    alt=""
                    style="padding: 0; cursor: pointer;"
                  >
                  </router-link>
                </div>
                <div class="col col-8 mt-3 mb-3">
                  <div class="card-block px-2">
                    <h4 class="card-title mt-2" style="color:var(--textactive)">
                      {{ report.title }}
                    </h4>
                    <p class="card-text">{{ report.summary }}</p>
                    <a :href="report.link" style="font-size: 0.9rem"
                      >View report</a
                    >
                    <hr class="hr-report" />
                    <div class="row f-row">
                      <div class="col col-12">
                        <table
                          class="table table-condensed table-borderless table-data-controls"
                        >
                          <tbody>
                            <tr>
                              <td
                                style="width: 30%"
                                class="txt-label-primary-4"
                              >
                                Author: {{ report.author }} /
                                {{ report.company }}
                              </td>
                              <td
                                style="width: 30%"
                                class="txt-label-primary-4 text-center"
                              >
                                Tag:
                                <template v-for="value in report.tag">
                                  <template v-if="value !== ''">
                                    <template v-for="(val, idx) in tags">
                                      <template v-if="val.id === parseInt(value)"
                                        ><template v-if="idx > 0">,</template
                                        >{{ val.name }}
                                      </template>
                                    </template>
                                  </template>
                                </template>
                              </td>
                              <td
                                style="width: 30%"
                                class="txt-label-primary-4 text-center"
                              >
                                Date: {{ report.publication_date | formatDate }}
                              </td>
                              <td
                                style="width: 10%"
                                class="txt-label-primary-4 text-right"
                              >
                                {{ report.likes }}
                                <button
                                  v-on:click="onLiked(report.id, report.liked)"
                                  type="submit"
                                  class="btn txt-label-primary-4"
                                >
                                  <i
                                    class="fa fa-thumbs-up"
                                    aria-hidden="true"
                                    v-bind:class="[
                                      report.liked === true ? 'liked' : ''
                                    ]"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiService } from "@/_services";
import moment from "moment";
export default {
  name: "Reports",
  props: {
    user: { required: true }
  },
  data() {
    return {
      allReports: [],
      // ========= pagination and search variables ============ //
      page: 1,
      itemsPerPage: 3,
      search: "",
      selectedTag: 0,
      tags: [],
      selectedAuthor: "ALL",
      authors: [],
      ValidateReports: 0
    };
  },
  created() {
    if (
      this.user.pk_idusers !== undefined &&
      this.user.pk_idusers !== null &&
      this.user.pk_idusers !== ""
    ) {
      this.user = this.$store.state.user.all.items;
      this.ValidateReports = 1;
    }
    this.getTags();
    document.title = "Reports | QS";
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format("MMM DD, YY");
      }
    }
  },
  watch: {
    itemsPerPage() {
      this.page = 1;
    }
  },
  computed: {
    reportsText() {
      // this will allow to search on defined fields
      return this.allReports.map(
        d =>
          d.title.toLowerCase() +
          " " +
          d.summary.toLowerCase() +
          " " +
          d.text.toLowerCase() +
          " " +
          d.author.toLowerCase() +
          " " +
          d.company.toLowerCase() +
          " " +
          d.publication_date
      );
    },
    filteredReports() {
      let rep = this.allReports;

      if (this.selectedTag > 0) {
        rep = rep.filter(d => {
          var searchTag = this.selectedTag.toString();
          if (d.tag.indexOf(searchTag) > -1) {
            return d;
          }
        });
      }

      // company filter
      if (this.selectedAuthor !== "ALL") {
        rep = rep.filter(
          d => d.company.toUpperCase() === this.selectedAuthor.toUpperCase()
        );
      }

      // search filter (for title, summary, text, author, company, date)
      if (this.search.length > 0) {
        rep = rep.filter(
          (d, i) => this.reportsText[i].indexOf(this.search.toLowerCase()) > -1
        );
      }
      return rep;
    },
    reports() {
      // this variable will be rendered
      let rep = this.filteredReports.slice(
        this.itemsPerPage * (this.page - 1),
        Math.min(this.allReports.length, this.itemsPerPage * this.page)
      );
      return rep;
    },
    pageCount() {
      return Math.ceil(this.filteredReports.length / this.itemsPerPage);
    }
  },
  methods: {
    getTags: function() {
      apiService.listTags().then(data => {
        if (data != null || data !== undefined) {
          var response = JSON.parse(data);
          this.tags = response.map(resp => {
            return {
              id: resp.pk,
              name: resp.fields.tag_name
            };
          });
        }
        this.getAuthor();
      });
    },
    getAuthor: function() {
      var count = 0;
      var idcompany = 0;
      apiService.listCompanyReport().then(data => {
        if (data != null || data !== undefined) {
          var response = JSON.parse(data);
          response.map(resp => {
            if (idcompany !== resp.pk_id_company) {
              this.authors.push({
                id: resp.pk_id_company,
                company: resp.company_name,
                analysts: []
              });
              response.map(respo => {
                if (resp.pk_id_company === respo.pk_id_company) {
                  if (
                    respo.PK_IdUsers !== null ||
                    respo.PK_IdUsers !== undefined
                  ) {
                    this.authors[count].analysts.push({
                      id: respo.PK_IdUsers,
                      name: respo.NameUser
                    });
                  }
                }
              });
              count += 1;
            }
            idcompany = resp.pk_id_company;
          });
        }
        this.getListReport();
      });
    },
    getListReport: function() {
      var dataList = {
        validate: this.ValidateReports,
        UserId: this.ValidateReports === 1 ? this.user.pk_idusers : 0
      };
      apiService.listReport(dataList).then(data => {
        if (data != null || data !== undefined) {
          this.allReports = [];
          var response = JSON.parse(data);
          response.map(resp => {
            this.allReports.push({
              id: resp.pk_id_report,
              img: resp.img,
              tag:
                resp.tags != null || resp.tags !== undefined
                  ? resp.tags.split(",")
                  : [],
              title: resp.title,
              summary: resp.summary,
              text: resp.text,
              link: resp.link,
              author: resp.NameUserCreate,
              company: resp.company_name,
              publication_date: resp.publication_date,
              likes: resp.likes,
              liked: resp.liked === "True" ? true : false
            });
          });
        } else {
          this.allReports = [];
        }
      });
    },
    onUserCompanySelection() {
      console.log("company selected");
    },
    onUserTagSelection() {
      console.log("tag selected");
    },
    onLiked(idReport, liked) {
      var dataLike = {
        ReportId: idReport,
        UserId: this.user.pk_idusers,
        Liked: liked === true ? "False" : "True"
      };
      apiService.likeReport(dataLike).then(data => {
        console.log(data);
        this.getListReport();
      });
    }
  }
};
</script>
